import {
  RADIUS_XL,
  RED_700,
  SPACING_1,
  SPACING_3,
  TEXT_FONT,
  WEB_PURPLE_EXTRA_LIT,
} from '@mnd-frontend/ui/shared/tokens';
import type { ChangeEvent } from 'react';
import { type FC, useId } from 'react';
import styled from 'styled-components';

const ErrorText = styled.span`
  display: block;
  font-size: 0.875rem; //token: web/body/sm
  color: ${RED_700};
`;

const InputWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${SPACING_1};
`;

const Input = styled.input`
  width: 100%;
  font-family: ${TEXT_FONT};
  font-size: 1rem;
  background: rgba(0, 0, 0, 0.05);
  border-radius: ${RADIUS_XL};
  padding: ${SPACING_1} ${SPACING_3};
  line-height: 150%;

  &:focus {
    outline-color: ${WEB_PURPLE_EXTRA_LIT};
  }
`;

interface Props {
  placeholder?: string;
  error?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

const EmailInput: FC<Props> = ({ placeholder, error, onChange }) => {
  const internalId = useId();

  return (
    <InputWrapper>
      <Input
        onChange={onChange}
        name="email"
        placeholder={placeholder}
        aria-describedby={internalId}
      />
      {!!error && <ErrorText id={internalId}>{error}</ErrorText>}
    </InputWrapper>
  );
};

export default EmailInput;
